import { createTheme } from '@mantine/core';
// Supports weights 100-900
import '@fontsource-variable/inter';
// font-family: 'Inter Variable', sans-serif;
import '@fontsource/noto-mono';

export const theme = createTheme({
  cursorType: 'pointer',
  fontFamily: 'Inter Variable, sans-serif',
  fontFamilyMonospace: 'Noto Mono, monospace',
});
